import { LayoutGrid, Tag } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

export function CategoryGrid({ categories, products, onPick }) {
  const count = (id) => products.filter((p) => id === "all" || p.category_id === id).length;
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="m-category-grid">
      {categories.map((c) => {
        const Icon = c.id === "all" ? LayoutGrid : Tag;
        return (
          <button key={c.id} onClick={() => onPick(c)} data-testid={`m-category-${c.id}`}
            className="relative aspect-square overflow-hidden rounded-2xl bg-[#1565c0] bg-cover bg-center text-left text-white shadow-md shadow-blue-900/20 transition-transform active:scale-[0.97]"
            style={c.image_url ? { backgroundImage: `url(${imgUrl(c.image_url)})` } : undefined}>
            <span className={cn("absolute inset-0", c.image_url ? "bg-gradient-to-t from-[#0b1f3a]/90 via-[#0b1f3a]/35 to-transparent" : "bg-[radial-gradient(circle_at_85%_10%,rgba(255,255,255,0.22),transparent_55%)]")} />
            {!c.image_url && <Icon className="absolute right-3 top-3 h-7 w-7 text-white/45" />}
            <span className="absolute inset-x-3 bottom-3">
              <span className="block font-display text-lg font-bold leading-tight">{c.name}</span>
              <span className="text-xs text-white/80">{count(c.id)} produto(s)</span>
            </span>
          </button>
        );
      })}
      {!categories.length && <p className="col-span-2 py-8 text-center text-sm text-slate-500">Nenhuma categoria encontrada.</p>}
    </div>
  );
}
